import { useNavigate } from 'react-router-dom';

const Cancel = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4 text-center">
      <h2>Payment Cancelled</h2>
      <p>Your payment was cancelled. Please try again.</p>
      <button
        className="btn btn-primary"
        style={{
          borderRadius: '50px',
          backgroundColor: '#db2217',
          border: 'none',
          padding: '10px 20px',
          color: '#fff',
        }}
        onClick={() => navigate('/')}
      >
        Go to Home
      </button>
    </div>
  );
};

export default Cancel;
